import { authEndpoints, type AccessSummary } from '@ventawiz/web-kit'

import { authRequest } from './request'

/**
 * What the app shell asks VentaWiz-Auth: which organisations this session
 * can switch to, and which other front ends exist.
 */

/**
 * The organisations reachable **in this application** — the pairs whose
 * `application` is the session's own, each with the selection handle a
 * switch sends back. From `GET /v1/session`, which is identified by the
 * refresh cookie and is the only source of those handles.
 */
export async function reachableOrganisations(application: string): Promise<AccessSummary[]> {
  const session = await authEndpoints.introspect()
  return session.reachable.filter((pair) => pair.application === application)
}

/** One front end, as `GET /v1/destinations` lists it. */
export type Destination = {
  key: string
  name: string
  description: string
  application: string
  /** A path on this origin, or (locally) an absolute URL. */
  url: string
}

/** `GET /v1/destinations` — public, the operators' list, in display order. */
export async function listDestinations(): Promise<Destination[]> {
  const body = await authRequest<{ items: Destination[] }>('/destinations')
  return body.items
}

/** This app's own key in that list, so the launcher does not offer it. */
export const THIS_DESTINATION = 'ventawiz'
